import React from "react";
import "../../../../../styles/ComponentsStyles/Operational/Academic/Students/StudentsDataTable.style.css";
import ProfileImg from "../../../../../assets/Images/TestImg/profileImage.png";
import ProfileRedirectIcon from "../../../../../assets/Icons/Universal/ProfileRedirectArrow.svg";
import ArrowUpIcon from "../../../../../assets/Icons/Universal/ProgressUp.svg";
import ArrowDownIcon from "../../../../../assets/Icons/Universal/ProgressDown.svg";
import StudentsStore from "../../../../../store/Academic/Students.store";
import { useNavigate } from "react-router-dom";
import FilterImg from "../../../../../assets/Icons/Universal/FilterDrop.svg";
const BigTable = ({ thead, data }) => {
  const { setStudentId, setStudentBehaviorModal } = StudentsStore();

  const navigate = useNavigate();
  const handelStudentProfileUrl = (_id) => {
    setStudentId(_id);
    navigate("profile", { state: "academic" });
  };

  return (
    <table className="w-fit" id="studentsDataTable">
      <thead>
        <tr>
          {thead.map((head, index) => (
            <th key={index}>{head}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.length > 0 ? (
          data.map((students, rowIndex) => (
            <tr key={rowIndex}>
              <td>
                <div
                  className="flex-row align-center g-1"
                  style={{ position: "relative" }}
                >
                  <img
                    src={ProfileImg}
                    alt="Profile"
                    style={{
                      width: "3rem",
                      height: "3rem",
                      borderRadius: "50%",
                    }}
                  />

                  <div className="flex-col align-start justify-start p-r-2">
                    <div
                      className="t-18 poppins text-align-left w-full"
                      style={{ color: "var(--textColor)" }}
                    >
                      {students.name}
                    </div>
                    <div
                      className="t-13 poppins text-align-left w-full"
                      style={{ color: "var(--grayColor)" }}
                    >
                      {students.gender}
                    </div>
                  </div>
                </div>
                <button
                  style={{
                    width: "1rem",
                    height: "1rem",
                    position: "absolute",
                    top: "0.5rem",
                    right: "0.5rem",
                    background: "transparent",
                    border: "none",
                    outline: "none",
                    cursor: "pointer",
                  }}
                  onClick={() => handelStudentProfileUrl(students.id)}
                  // to={"/operational/academic/students/profile"}
                >
                  <img
                    src={ProfileRedirectIcon}
                    alt="Profile"
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </button>
              </td>
              <td className="t-13">{students.id}</td>
              <td className="t-13">{students.class}</td>
              <td>
                <div className="flex-col align-center justify-center">
                  <div className="t-13" style={{ color: "var(--)" }}>
                    {students.reportingTeacher.name}
                  </div>
                  <div className="t-13" style={{ color: "var(--grayColor)" }}>
                    ID: {students.reportingTeacher.id}
                  </div>
                </div>
              </td>
              <td className="t-13">{students.attendance}</td>
              <td>
                <div className="flex-row align-center justify-center">
                  <span className="t-13">{students.performance.score}</span>
                  <span>
                    <img
                      src={
                        students.performance.trend.toLowerCase() === "down"
                          ? ArrowDownIcon
                          : ArrowUpIcon
                      }
                      style={{ width: "1rem", height: "0.7rem" }}
                      alt="status"
                    />
                  </span>
                </div>
              </td>
              <td className="t-13">{students.latestPayment}</td>
              <td className="t-13">{students.subjectStrength}</td>
              <td className="t-13">{students.subjectWeakness}</td>
              <td className="t-13">{students.extraActivity}</td>
              <td
                className="t-13"
                style={{
                  background: "var(--orangeColor2) !important",
                  color: "var(--orangeColor1)",
                  position: "relative",
                }}
              >
                <button
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    background: "transparent",
                    border: "none",
                    outline: "none",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setStudentBehaviorModal();
                    setStudentId(students.id);
                  }}
                >
                  <img
                    src={FilterImg}
                    style={{ width: "1rem", height: "1rem" }}
                    alt="filter btn"
                  />
                </button>
                <span>{students.behavior}</span>
              </td>
              <td className="t-13">
                {students.achievements.length > 0 ? (
                  <ol className="flex-col align-start justify-start">
                    {students.achievements.map((achievement) => (
                      <li className="text-align-left">{achievement}</li>
                    ))}
                  </ol>
                ) : (
                  "No Achievements Yet"
                )}
              </td>
              <td>{students.likeToDo}</td>
              <td>{students.address}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={thead.length} className="text-center">
              No data available
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default BigTable;
